import React from 'react';
import styled from 'styled-components';

const StyledBurger = styled.button`
  position: relative;
  // top: 4%;
  // left: 8.5rem;
  margin-right: 3em;
  transform: ${({ open }) => open ? 'translateX(30em)' : 'translateX(0em)'};
  transition: transform 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 2rem;
  height: 2rem;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  z-index: 10;

  @media (max-width: 480px) {
    transform: ${({ open }) => open ? 'translateX(80vw)' : 'translateX(0em)'};
    width: 1.7rem;
    height: 1.7rem;
  }

  &:focus {
    outline: none;
  }

  div {
    height: 0.25rem;
    background: ${({ open }) => open ? '#ffffff' : '#8b5dbc'};
    border-radius: 10px;
    transition: all 0.3s linear;
    position: relative;
    transform-origin: 1px;
    :first-child {
      transition-delay: .2s;
      width: ${({ open }) => open ? '2rem' : '2.2rem'};
      transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
      @media (max-width: 480px) {
        width: ${({ open }) => open ? '1.7rem' : '1.7rem'};
        transform: ${({ open }) => open ? 'rotate(45deg)' : 'rotate(0)'};
      }
    }

    :nth-child(2) {
      width: 1.7rem;
      opacity: ${({ open }) => open ? '0' : '1'};
      transform: ${({ open }) => open ? 'translateX(20px)' : 'translateX(0)'};
      @media (max-width: 480px) {
        width: ${({ open }) => open ? '1.2rem' : '1.4rem'};
      }
    }

    :nth-child(3) {
      transition-delay: .2s;
      width: ${({ open }) => open ? '2rem' : '1.3rem'};
      transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
      @media (max-width: 480px) {
        width: ${({ open }) => open ? '1.7rem' : '1rem'};
        transform: ${({ open }) => open ? 'rotate(-45deg)' : 'rotate(0)'};
      }
    }
  }

`;

const Burger = ({ open, onClick, burgerRef }) => {
  return (
    <StyledBurger ref={burgerRef} open={open} onClick={onClick}>
      <div />
      <div />
      <div />
    </StyledBurger>
  )
}

export default Burger;
